import { render, staticRenderFns } from "./ExtratoHonorariosProtesto.vue?vue&type=template&id=74164c67&scoped=true&"
import script from "./ExtratoHonorariosProtesto.vue?vue&type=script&lang=js&"
export * from "./ExtratoHonorariosProtesto.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoHonorariosProtesto.vue?vue&type=style&index=0&id=74164c67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74164c67",
  null
  
)

export default component.exports